import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { config } from '../../config';
import CheckoutSection from './CheckoutSection';
import Footer from '../../components/Footer';


const LandingPage = () => {
  const { slug } = useParams();
  const apiUrl = config.apiUrl;

  const [html, setHtml] = useState('');
  const [css, setCss] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const res = await axios.get(`${apiUrl}/landing-pages/offer/${slug}`);
        const d = res.data.data;

        setHtml(d.html || '');
        setCss(d.css || '');
      } catch (error) {
        console.error('Landing page load failed', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPage();
  }, [slug, apiUrl]);

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '40px' }}>Loading...</div>;
  }

  return (
    <>
      {/* Inject CSS */}
      <style>{css}</style>

      {/* Render HTML */}
      <div dangerouslySetInnerHTML={{ __html: html }} />

      <CheckoutSection />

      <Footer />
    </>
  );
};

export default LandingPage;
